export const testimonials = [
  {
    quote: 'Antes tenía material repartido entre apuntes y archivos. Tener todo organizado me facilita muchísimo preparar cada capacitación.',
    name: 'Nicolás Fernández',
    role: 'Instructor de detailing',
  },
  {
    quote: 'Las clases y planillas me permiten adaptar el contenido a cada grupo sin tener que arrancar de cero.',
    name: 'Martín López',
    role: 'Capacitador de estética automotriz',
  },
  {
    quote: 'Lo que más valoro son las prácticas, evaluaciones y escenarios. Le dan mucha más estructura a la enseñanza.',
    name: 'Franco Benítez',
    role: 'Detailer e instructor',
  },
  {
    quote: 'El Atlas Visual y las preguntas son muy útiles para explicar y comprobar si los alumnos realmente entendieron.',
    name: 'Sebastián Gómez',
    role: 'Formador en detailing',
  },
];
